import openWindow from '@/script/openWindow.mjs'
import {useIsLicensed} from '@/biz/license.jsx'

export const canDesignWf = () => () => {
    const isLicensed = useIsLicensed()

    if (isLicensed('M00030002')) {
        return function (nodes) {
            return [...nodes].filter(node => {
                const {bizNodeType, demoType, pkid} = node.data

                return (
                    pkid &&
                    'WF' === bizNodeType &&
                    'DEMO' === demoType
                )
            })
        }
    }
    else {
        return () => []
    }
}

export const designWf = () => () => {
    return async function (nodes) {
        for (const n of nodes) {
            const {pkid: wfId} = n.data
            openWindow('/FlowDetail', {wfId})
        }
    }
}
